export interface LandingPageOption {
  apiCode: number;
  identifier: string;
  route: string;
}

export const LANDING_PAGE_OPTIONS: LandingPageOption[] = [
  { 
    apiCode: 10146, 
    identifier: 'home', 
    route: '/home'
  },
  { 
    apiCode: 10147, 
    identifier: 'recentTransmission', 
    route: '/clinician'
  },
];

// Default landing page if code is not found
export const DEFAULT_LANDING_PAGE = LANDING_PAGE_OPTIONS[0];

export interface myAccountModel {
  userRecordId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  altFirstName: string;
  altLastName: string;
  credentialsCd: number;
  departmentCd: number;
  individualTypeCd: number;
  administratorFlg: boolean;
  commCenterFlg: boolean;

  showAppPref: boolean;
  activatorClinicFlg: boolean;

  securityStamp: string;
  applicationAffinityCd: string;

  inboxSortPreferenceCd: number;
  landingPagePreferenceCd?: number | string;

  contactInfo: contactInfoSection;
  afterHoursContact: AfterHoursContactSection;
  assignedLocations: location[];


  userId: string;

   
}

export interface location {
  customerLocationId: number;
  name: string;
  primary: boolean;
}

export interface AfterHoursContactSection {
  onCallContactTypeCd: number;
  onCallEmail: string;
  onCallFax: PhoneSection;
  onCallPhone: PhoneSection;
  onCallSms: string;
}
export interface contactInfoSection {
  address: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  stateCd: number;
  countryCd: number;
  zipCode: string;
  mainPhone: PhoneSection;
  secondaryPhone: PhoneSection;
  clinicPhone: PhoneSection;
  clinicFax: PhoneSection;
  fax: PhoneSection;
  email: string;
  textMessageId: string;
  callContactTypeCd: number;
  patientCallSMS: string;
  smsOptedForMfaFlg ? : any;
}

export interface PhoneSection {
  defaultCountryCode: string;
  countryCode: string;
  areaCode: string;
  phoneNum: string;
  label: string;
  optedForMfaFlg ? : any;
}

export interface ErrorResponse{
  fieldErrors: string[];
  actionErrors: ActionError[];
}


export interface ActionError{
  message: string;
  parameters: { [name: string]: ActionError };

}
